
import { Doughnut } from 'react-chartjs-2';

const DoughnutStats = ({ statistics }) => {
    const colorsDoughnut = [
        'rgba(0, 0, 143, 0.6)',   // AXA Blue 400
        'rgba(210, 71, 35, 0.6)',  // Sienna 400
        'rgba(19, 134, 54, 0.6)',  // Success Green
        'rgba(255, 188, 17, 0.6)', // Warning Yellow
        'rgba(73, 118, 186, 0.6)', // Info Ocean 200
        'rgba(201, 20, 50, 0.6)',  // Danger Red
        'rgba(138, 115, 51, 0.6)', // Apache 200
        'rgba(91, 123, 115, 0.6)', // Viridian 200
        'rgba(2, 113, 128, 0.6)',  // Teal 200
        'rgba(145, 65, 70, 0.6)',  // Tosca 200
    ];

    const hoverColors = [
        'rgba(0, 0, 143, 1)',   // AXA Blue 400
        'rgba(210, 71, 35, 1)',  // Sienna 400
        'rgba(19, 134, 54, 1)',  // Success Green
        'rgba(255, 188, 17, 1)', // Warning Yellow
        'rgba(73, 118, 186, 1)', // Info Ocean 200
        'rgba(201, 20, 50, 1)',  // Danger Red
        'rgba(138, 115, 51, 1)', // Apache 200
        'rgba(91, 123, 115, 1)', // Viridian 200
        'rgba(2, 113, 128, 1)',  // Teal 200
        'rgba(145, 65, 70, 1)',  // Tosca 200
    ];

    const contratDureeData = {
        labels: statistics.pourcentage_contrat_duree.contrats_duree_stats.map(item => item.duree),
        datasets: [
            {
                label: 'Pourcentage de contrats',
                data: statistics.pourcentage_contrat_duree.contrats_duree_stats.map(item => item.pourcentage),
                backgroundColor: statistics.pourcentage_contrat_duree.contrats_duree_stats.map((_, index) => colorsDoughnut[index % colorsDoughnut.length]),
                hoverBackgroundColor: statistics.pourcentage_contrat_duree.contrats_duree_stats.map((_, index) => hoverColors[index % hoverColors.length]),
                borderWidth: 2,
                hoverOffset: 10,
            },
        ],
    };

    const contratDureeOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%', // Réduction de la taille du trou pour plus de place aux labels
        plugins: {
            legend: {
                position: 'bottom', // Garde la légende en bas pour plus de clarté
                labels: {
                    color: '#00008F', // AXA Blue pour les labels de la légende
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                    padding: 20, // Ajoute du padding pour éviter le chevauchement
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const label = tooltipItem.label || '';
                        const value = tooltipItem.raw;
                        return `${label}: ${value}%`;
                    },
                },
            },
            datalabels: {
                color: '#FFFFFF', // Couleur des labels à l'intérieur du doughnut
                font: {
                    size: 16,
                    weight: 'bold',
                },
                formatter: (value) => `${value}%`, // Formatte les données en pourcentage
            },
        },
    };

    return (
        <div className="bg-white p-8 rounded-lg shadow-lg h-auto overflow-auto">
            <h2 className="text-2xl font-bold mb-6 text-center text-axa-blue-400">Répartition des contrats par durée</h2>
            <div className="relative w-full h-72">
                <Doughnut data={contratDureeData} options={contratDureeOptions} />
            </div>
        </div>
    );
}

export default DoughnutStats;